import {MenuItem, OutlinedInput, Select, Typography, Box} from '@mui/material'
import {styled} from '@mui/material/styles'
import {CloseOutlined, InfoOutlined} from '@mui/icons-material'

const PREFIX = 'BreadCrumbComponent'

const classes = {
  icon: `${PREFIX}-icon`,
  gutterRight: `${PREFIX}-gutterRight`
}

const SelectInput = styled(OutlinedInput)(({theme}) => ({
  border: 'none',
  '& .MuiInputBase-input': {
    maxWidth: '300px',
    fontSize: theme.typography.subtitle1.fontSize,
    '& .Mui-focused': {
      borderColor: theme.palette.hpPrimary
    }
  }
}))

const StyledSelect = styled(Select)(({theme}) => ({
  height: '35px',
  borderColor: theme.palette.hpPrimary,
  backgroundColor: theme.palette.hpPrimary,
  color: theme.palette.hpWhite,
  [`& .${classes.icon}`]: {
    fontSize: theme.typography.h5.fontSize,
    color: theme.palette.hpWhite
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },

  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryDark
  }
}))
const StyledTypography = styled(Typography)(({theme}) => ({
  height: '35px',
  borderColor: theme.palette.hpPrimary,
  backgroundColor: theme.palette.hpPrimary,
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpWhite,
  padding: theme.spacing(0.5, 1.5),
  borderRadius: '4px',
  cursor: 'default'
}))
export const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  '&.Mui-selected': {
    backgroundColor: theme.palette.hpWhite
  },
  '&.Mui-selected:focus': {
    backgroundColor: 'inherit'
  },
  '&:active': {
    backgroundColor: theme.palette.hpWhite
  },
  '&.Mui-selected:active': {
    backgroundColor: theme.palette.hpWhite
  }
}))

export const StyledBannerBox = styled(Box)(({theme}) => ({
  position: 'fixed',
  top: theme.spacing(10),
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: theme.palette.info.light,
  color: theme.palette.hpBlack,
  padding: theme.spacing(2, 1),
  boxShadow: theme.shadows[3],
  textAlign: 'center',
  zIndex: 5001,
  minWidth: '50%',
  maxWidth: '80vw',
  fontSize: theme.typography.subtitle1.fontSize
}))

export const StyledBannerContent = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start'
}))

export const StyledBannerIcon = styled(InfoOutlined)(({theme}) => ({
  fontSize: theme.typography.h5.fontSize,
  marginRight: theme.spacing(1),
  color: theme.palette.hpAccentPersianGreen
}))

export const StyledBannerTextBox = styled(Box)(() => ({
  textAlign: 'left'
}))

export const StyledBannerClose = styled(CloseOutlined)(({theme}) => ({
  cursor: 'pointer',
  marginLeft: 'auto',
  color: theme.palette.hpBaseDarker,
  fontSize: theme.typography.h5.fontSize
}))

export {classes, SelectInput, StyledSelect, StyledTypography}
